var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetZeroAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56406 5.81055L7.09668 7.27532",
    stroke: "#A0AEC0",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54053 3.50032V5.83463H10.879L13.2174 3.50032L11.6583 2.72241L10.879 1.16602L8.54053 3.50032Z",
    stroke: "#A0AEC0",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78662 2.31641C4.11985 2.47979 2.05721 4.71442 2.1119 7.38091C2.16659 10.0474 4.31912 12.1959 6.99035 12.2502C9.66158 12.3045 11.8999 10.2452 12.0633 7.58318",
    stroke: "#A0AEC0",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83251 7.5834C9.67533 9.02022 8.43338 10.0921 6.98641 10.0397C5.53944 9.98727 4.37855 8.82843 4.32606 7.38402C4.27358 5.93962 5.34731 4.69987 6.78668 4.54297",
    stroke: "#A0AEC0",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetZeroAssessment);
export default __webpack_public_path__ + "static/media/net_zero_assessment.453808d4f3d864be0bf1b02e0f646a77.svg";
export { ForwardRef as ReactComponent };